// ===== Packages =====

import {
    Node,
    Element,
}                           from 'slate';
import { v4 as uuidv4 }     from 'uuid';

// ===== Interfaces =====

import {
    BlockQuoteOptions,
    EditorNode,
    BlockQuoteNode,
}                           from '../interfaces';
import LineInterface        from '../interfaces/lineInterface';
import ListableInterface    from '../interfaces/listableInterface';

const BLOCK_BLOCK_QUOTE_TYPE = 'block-quote';

const isBlockQuoteElement = (node: EditorNode | Node): boolean => Element.isElement(node)
    && 'type' in node
    && node.type === BLOCK_BLOCK_QUOTE_TYPE;

const newBlockQuoteElement = (options: BlockQuoteOptions = {}): BlockQuoteNode => ({
    type: BLOCK_BLOCK_QUOTE_TYPE,
    paragraphId: options.paragraphId || uuidv4(),
    isLine: true,
    isListable: true,
    children: [{ text: options.text || '' }],
});

export default {
    TYPE: BLOCK_BLOCK_QUOTE_TYPE,
    isBlockQuoteElement,
    ...LineInterface,
    ...ListableInterface,
    newBlockQuoteElement,
};
